// components/StudiosCarousel.jsx
import React from "react";
import { STUDIOS } from "../lib/data";

export default function StudiosCarousel() {
  // Duplicate the array for seamless infinite scroll
  const items = [...STUDIOS, ...STUDIOS];

  return (
    <div className="bg-white dark:bg-[#161b22] pt-2" style={{background : "rgb(var(--canvas))"}}>
      <p className="used-by-text text-center mb-6">
        Used by major Production Companies
      </p>
      <div className="studios-carousel-section">
        {/* Fade masks */}
        <div className="absolute left-0 top-0 bottom-0 w-1 z-10 pointer-events-none bg-gradient-to-r from-white dark:from-[#161b22] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-1 z-10 pointer-events-none bg-gradient-to-l from-white dark:from-[#161b22] to-transparent" />

        <div className="flex marquee mb-6" style={{background: "white"}}>
          {items.map(({ src, alt }, i) => (
            <div
              key={`${src}-${i}`}
              className="studio-card"
            >
              <img
                src={`/LandingSite/${src}`}
                alt={alt}
                loading="lazy"
                className="
                  h-12 w-auto max-w-[120px] object-contain
                  transition-all duration-300
                "
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.innerHTML = `<span class="font-syne font-extrabold text-[13px] text-navy dark:text-[#e6edf3]">${alt}</span>`;
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
